import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { ArrowRightIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { Link, linkOverlayBoundaryClassName } from '@change/ds-core-ui/Link';

import { translationKey } from '@change-corgi/core/i18n';
import { TypedTranslate } from '@change-corgi/core-react/i18n';

import { SectionIntro } from '#src/app/pages/about/shared/components';

import { RESOURCES } from './consts';

export const Resources: React.FC<EmptyProps> = () => {
	return (
		<div className="flex flex-col gap-8">
			<SectionIntro
				eyebrow={translationKey('corgi.press_page.resources.eyebrow')}
				heading={translationKey('corgi.press_page.resources.heading')}
				align="start"
			/>
			<ul className="border-stroke-weaker flex flex-col border-t">
				{RESOURCES.map(({ id, href, label, note }) => (
					// the overlay link makes the whole row clickable; the arrow is the row's only trailing indicator
					<li
						key={id}
						className={cn(
							'border-stroke-weaker hover:bg-background-raised relative flex items-center justify-between gap-4 border-b px-1 py-5',
							linkOverlayBoundaryClassName,
						)}
						data-qa="press-resource-row"
					>
						<div className="flex flex-col gap-1">
							<Link overlay href={href} target="_blank" bold underline={false} variant="inherit" size="medium">
								<TypedTranslate value={label} />
							</Link>
							<Text as="p" size="small" className="text-typography-weak">
								<TypedTranslate value={note} />
							</Text>
						</div>
						<ArrowRightIcon size="small" className="text-icon-weak" data-testid="press-resource-arrow" />
					</li>
				))}
			</ul>
		</div>
	);
};
